module.exports = __webpack_public_path__ + "images/asmleasing_smallbd155c1ce22792855b85d962b95f5ec8.png";